import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var selectionIcon = /*#__PURE__*/React.createElement("svg", {
  height: "48",
  width: "48",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.07 32.745a1.17 1.17 0 0 1-.75-.285l-6.435-5.685.495-.555a1.5 1.5 0 0 1 2.13-.135l4.5 3.93L32.67 15.39a1.5 1.5 0 0 1 2.115-.15l.57.495L21 32.355a1.11 1.11 0 0 1-.78.375l-.15.015Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "24",
  cy: "24",
  r: "23",
  stroke: "currentColor",
  strokeWidth: "2"
})));

export { selectionIcon as default };
//# sourceMappingURL=selectionIcon.js.map
